export const ScreenSize = () => {
    return {
        height: window.outerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight,
        width: window.outerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth,
    };
};
